<div class="bb-media-player">
	<video #media preload="auto" [attr.src]="trustedSrc" crossOrigin="anonymous" volume="1.0" webkit-playsinline playsinline></video>
</div>
